import React, { useState } from "react";

const DeleteConfirmationModal = ({
  onClose,
  onConfirm,
  itemCount,
  itemType = "item"
}) => {
  const [confirmText, setConfirmText] = useState("");
  const isConfirmEnabled = confirmText.toLowerCase() === "delete";

  return (
    <div
      className="fixed inset-0 bg-gray-900/50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 w-full max-w-xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 font-bold text-2xl"
        >
          &times;
        </button>
        <div className="text-center">
          <h2 className="text-xl font-bold mb-4">Confirm Deletion</h2>
          <p className="text-lg mb-4">
            Are you sure you want to delete {itemCount} selected {itemType}(s)?
          </p>
          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-2">
              Type "delete" to confirm
            </p>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="Type 'delete' to confirm"
              autoFocus
            />
          </div>
          <div className="flex justify-center space-x-4">
            <button
              onClick={onConfirm}
              disabled={!isConfirmEnabled}
              className={`${isConfirmEnabled
                ? "bg-red-500 text-white hover:bg-red-600"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                } px-4 py-2 rounded`}
            >
              Confirm
            </button>
            <button
              onClick={onClose}
              className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
